import { render, staticRenderFns } from "./SettingEditTabAccount.vue?vue&type=template&id=29c5119a&"
import script from "./SettingEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./SettingEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./SettingEditTabAccount.vue?vue&type=style&index=0&id=29c5119a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports